import { SubSection } from "@lumen-energy/design-system"

export const Setting = ({
  children,
  label,
  description,
  actionButton,
}: {
  children: React.ReactNode
  label: string
  description: string
  actionButton?: JSX.Element
}) => {
  return (
    <SubSection.Root>
      <SubSection.Header bg="white">
        <SubSection.Title>{label}</SubSection.Title>
        <SubSection.Subtitle className="font-light text-grey-500">
          {description}
        </SubSection.Subtitle>
        {actionButton ? <SubSection.Actions>{actionButton}</SubSection.Actions> : null}
      </SubSection.Header>
      <SubSection.Body className="col-span-5 mb-10 lg:mb-0">{children}</SubSection.Body>
    </SubSection.Root>
  )
}
